import * as array from 'd3-array'
import { scaleBand } from 'd3-scale'
import * as util from 'infographic-util'
import * as d3 from 'd3-selection'
import container from './container'
import * as colors from 'colors'
import basicAnimation from './animations/basic-animation'

const MAX_ARROW_WIDTH = 250
const ARROW_WIDTH_EXTENDED = 100 // The arrow is shorter when we're showing the extended design

export const animations = [
  basicAnimation
]

export const preAnimate = function (chart, selection, series) {
  let seriesData = series.selection().data()
    , dimensions = chart.datum().dimensions
    , hasDescription = seriesData.some(s => s.subtitle)
    , config = chart.datum().axes.infographic
    , grid = chart.layout.getGrid(dimensions, hasDescription ? 2 : 1)
    , defs = d3.select(chart.node().ownerSVGElement).selectAll('defs')
    , height = grid.height - 10
    , scale = scaleBand()
                .domain(array.range(seriesData.length))
                .range([0, height])
    , tipHeight = scale.bandwidth() * .25
    , serieColors = new Set

  scale = scale.range([0, height - tipHeight]) // Re-adjust for the tipHeight

  let arrowWidth = Math.min(grid.width, MAX_ARROW_WIDTH)
    , extension = Math.max(grid.width - arrowWidth, 0)

  if (extension) {
    // Decrease the width of the arrow
    arrowWidth = ARROW_WIDTH_EXTENDED
    extension = grid.width - arrowWidth
  }

  let processes = grid.blocks.map(block => {
    let points = seriesData.map((serie, idx) => {
      let point = util.getPoint(block.range.id, serie)
      point.idx = idx // stage
      point.offset = scale(idx)
      point.height = scale.bandwidth()
      point.tipHeight = tipHeight
      point.arrowWidth = arrowWidth
      point.extension = extension
      serieColors.add(point.color)
      return point
    })

    points.reverse() // So the top stages are above the lower stages in the DOM

    return {
      block,
      points
    }
  })

  defs.call(util.coloredGradients, 'process', Array.from(serieColors), [0, .2, .6, .8], chart.defaultTransition)
      .selectAll('linearGradient')
      .each(function (color) {
        d3.select(this)
          .selectAll('stop')
          .attr('stop-color', (d, idx) => {
            switch (idx) {
              case 0:
                return colors.adjustLightness(colors.lookup(color), 30)
              case 1:
              case 2:
                return colors.adjustLightness(colors.lookup(color), 5)
              case 3:
                return colors.adjustLightness(colors.lookup(color), -10)
            }
          })
     })

  selection.call(container, chart, processes, config)
}
